
import Autonio from "../../../assets/filled/Autonio.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AutonioIcon({ className, dataTestid = "AutonioIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Autonio data-testid={dataTestid} className={classes} {...rest} />
  );
}
